import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=0ee64554&"
import script from "./TheMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee64554')) {
      api.createRecord('0ee64554', component.options)
    } else {
      api.reload('0ee64554', component.options)
    }
    module.hot.accept("./TheMenuItem.vue?vue&type=template&id=0ee64554&", function () {
      api.rerender('0ee64554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheMenuItem.vue"
export default component.exports